import React, { useEffect, createElement } from 'react';
import { StickyTopBar } from './components/StickyTopBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { TransformationSection } from './components/TransformationSection';
import { ProductBreakdown } from './components/ProductBreakdown';
import { ValueStack } from './components/ValueStack';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { MetaPixel } from './components/MetaPixel';
function loadFontsAsync() {
  const preconnects = [{
    href: 'https://fonts.googleapis.com',
    crossorigin: false
  }, {
    href: 'https://fonts.gstatic.com',
    crossorigin: true
  }, {
    href: 'https://cdn.magicpatterns.com',
    crossorigin: true
  }];
  preconnects.forEach(({
    href,
    crossorigin
  }) => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = href;
    if (crossorigin) link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
  const fontUrl = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&display=swap';
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'style';
  link.href = fontUrl;
  link.onload = function () {
    ;
    (this as HTMLLinkElement).rel = 'stylesheet';
  };
  document.head.appendChild(link);
  const noscript = document.createElement('noscript');
  const fallback = document.createElement('link');
  fallback.rel = 'stylesheet';
  fallback.href = fontUrl;
  noscript.appendChild(fallback);
  document.head.appendChild(noscript);
}
export function App() {
  useEffect(() => {
    document.title = 'Nutrición Canina Fácil';
    loadFontsAsync();
    const heroPreload = document.createElement('link');
    heroPreload.rel = 'preload';
    heroPreload.as = 'image';
    heroPreload.type = 'image/webp';
    heroPreload.href = 'https://cdn.magicpatterns.com/uploads/juvrdCDTRt1qFbZEHp6o8m/Imagen_ebook_portada_primera.webp';
    heroPreload.fetchPriority = 'high';
    document.head.appendChild(heroPreload);
  }, []);
  return <div className="min-h-screen bg-cream font-sans selection:bg-primary selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <StickyTopBar data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />

        <TransformationSection data-id="element-6" />
        <ProductBreakdown data-id="element-7" />
        <OfferSection data-id="element-8" />
        <ValueStack data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <Testimonials data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>

      {/* Simple Footer */}
      <footer className="bg-charcoal text-white/60 py-8 text-center text-sm" data-id="element-14">
        <div className="max-w-7xl mx-auto px-4" data-id="element-15">
          <p data-id="element-16">
            © {new Date().getFullYear()} Nutrición Canina Fácil. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs text-white/40" data-id="element-17">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}